import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import AnotherLogoPremiumWhiteIcon from '../../../static/icons/logo_premium_white.svg';
import * as Actions from '../../actions';
import Icon from '../../components/Icon/Icon';
import ButtonT3 from '../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Theme } from '../../components/lib/ButtonT3/constants';
// constant
import { MiniCoachmarkTypes } from '../../constants/MiniCoachmark';
import { message as m } from '../../constants/Welcome';
// util
import { getInDomain } from '../../domains/externalUtils';
import {
  getCurrentPathnameFromState,
  getMyMusicPath,
  isPathInNowPlayingPath,
} from '../../lib/RouteUtils';

import { ModalContainer } from './Modal';

import './ModalPremiumWelcome.scss';

export class ModalPremiumWelcome extends React.Component {
  static propTypes = {
    welcomeType: PropTypes.string.isRequired,
    intl: PropTypes.object,
    isAudioPlaying: PropTypes.bool,
    pauseTrack: PropTypes.func,
    openMiniCoachmark: PropTypes.func.isRequired,
    updateSettings: PropTypes.func,
    onClose: PropTypes.func,
    isNowPlayingPath: PropTypes.bool,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentWillMount() {
    if (this.props.isNowPlayingPath) {
      this.context.router.push(getMyMusicPath());
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isAudioPlaying || nextProps.isAudioPlaying) {
      this.props.pauseTrack({ logPlaybackActionsAnalytics: false });
    }
  }

  onClickPremiumWelcome = e => {
    e.stopPropagation();
    this.props.updateSettings({ seenWebPremiumWelcome: true });
    this.props.onClose();
    this.props.openMiniCoachmark(MiniCoachmarkTypes.FIRST_TIME_PREMIUM_WELCOME_SEARCH);
  };

  render() {
    return (
      <ModalContainer className='Modal--premiumWelcome'>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div className='PremiumWelcome' onClick={this.onClickPremiumWelcome}>
          <div className='PremiumWelcome__content'>
            <div className='PremiumWelcome__content__icon'>
              <Icon className='premium__icon' glyph={AnotherLogoPremiumWhiteIcon} />
            </div>
            <div className='PremiumWelcome__content__header'>
              <FormattedMessage {...m.welcomeToPandoraPremium} />
            </div>
            <div className='PremiumWelcome__content__body'>
              <div className='PremiumWelcome__content__body__text'>
                <FormattedMessage {...m.pandoraPremiumFeatures} />
              </div>
            </div>
            <div className='PremiumWelcome__buttonWrapper'>
              <ButtonT3
                theme={ButtonT3Theme.DARK}
                isBlock={true}
                onClick={this.onClickPremiumWelcome}
              >
                <FormattedMessage {...m.getStarted} />
              </ButtonT3>
            </div>
          </div>
        </div>
      </ModalContainer>
    );
  }
}

export const mapStateToProps = state => {
  const currentPath = getCurrentPathnameFromState(state) || '';
  const isNowPlayingPath = isPathInNowPlayingPath(currentPath);
  const isAudioPlaying = getInDomain('playback.utils.isAudioPlaying')(state);

  return {
    isAudioPlaying,
    isNowPlayingPath,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateSettings: Actions.Api.ApiUpdateSettings,
      pauseTrack: Actions.UseCases.pauseTrack,
      openMiniCoachmark: Actions.MiniCoachmark.openMiniCoachmark,
    },
    dispatch,
  );
};

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl);

export default enhance(ModalPremiumWelcome);
